import styled from 'styled-components'

import { helpers } from 'styles'

export const Faded = styled.div`
	color: ${helpers.color.textMuted};
	font-size: 13px;
`
